export default "__VITE_ASSET__DeSh3hZ7__"